<template>
  <div >
    <div :class="{'opacity-50': !isPlanProfesional}">
    <vx-row>
      <div class="vx-col w-full  lg:w-1/2 sm:w-full pt-5">
        <h4 class="pb-3">Clave Customer ID</h4>
        <a href="https://ayuda.verificamex.com/article/67-api-key" target="_blank">Más información<feather-icon icon="ExternalLinkIcon" class="top-1" svgClasses="w-4 h-4"/></a>

        <vx-input-group>
          <template slot="prepend">
            <div class="prepend-text bg-primary">
              <a
                @click="copyApiKeyId"
                class="white cursor-pointer">
                <feather-icon  icon="KeyIcon" class="top-4" svgClasses="w-5 h-5"/> Copiar</a>
            </div>
          </template>
          <vs-input
            readonly
            icon-no-border
            icon-pack="feather"
            v-model="apiKeyId"
            class="w-full mt-0" />
        </vx-input-group>


      </div>
    </vx-row>
    <vx-row class="mt-5">
      <div class="vx-col w-full  lg:w-1/2 sm:w-full pt-5">
        <h4 class="pb-3 mt-5">Clave SECRET </h4>
        <a href="https://ayuda.verificamex.com/article/66-integracion-api" target="_blank">Más información<feather-icon icon="ExternalLinkIcon" class="top-1" svgClasses="w-4 h-4"/></a>

        <vx-input-group class="mb-base">

            <template slot="prepend">
              <div class="prepend-text bg-primary">
                <a
                  @click="copyApiKeySecret"
                  class="white cursor-pointer"><feather-icon  icon="KeyIcon" class="top-4" svgClasses="w-5 h-5"/> Copiar</a>
              </div>
            </template>

          <vs-input
            readonly
            :type="type"
            icon-no-border
            icon-pack="feather"
            v-model="apiKeySecret"
            class="w-full mt-0" />

          <div class="form-control-position field-icon bg-b">
            <a @click="showKey" class="bg-b">
              <feather-icon :icon="icon" class="top-4 " svgClasses="w-5 h-5 icon-color"></feather-icon>
            </a>
          </div>
        </vx-input-group>

      </div>
    </vx-row>
    <vx-row>
      <vs-button :disabled="!isPlanProfesional" @click="resetApi" class="btn-secundary" type="filled"><b>Resetar Claves</b></vs-button>
    </vx-row>
    <vx-row class="mt-5">
      <div class="vx-col w-full  lg:w-1/2 sm:w-full pt-5">
        <h4 class="pb-3 mt-5">Clave de webhooks</h4>
        <p class="pb-3">Úsala para comprobar que los avisos que llegan a tu webhook los envió Verificamex Firma.</p>

        <vx-input-group class="mb-base">

            <template slot="prepend">
              <div class="prepend-text bg-primary">
                <a
                  @click="copyWebhookSecret"
                  class="white cursor-pointer"><feather-icon  icon="KeyIcon" class="top-4" svgClasses="w-5 h-5"/> Copiar</a>
              </div>
            </template>

          <vs-input
            readonly
            :type="webhookSecretType"
            icon-no-border
            icon-pack="feather"
            v-model="webhookSecret"
            class="w-full mt-0" />

          <div class="form-control-position field-icon bg-b">
            <a @click="showWebhookSecret" class="bg-b">
              <feather-icon :icon="webhookSecretIcon" class="top-4 " svgClasses="w-5 h-5 icon-color"></feather-icon>
            </a>
          </div>
        </vx-input-group>

      </div>
    </vx-row>
    <vx-row>
      <vs-button :disabled="!isPlanProfesional" @click="resetWebhookSecret" class="btn-secundary" type="filled"><b>Regenerar clave de webhooks</b></vs-button>
    </vx-row>
    </div>

    <vs-button v-if="!isPlanProfesional" class="position-btn" size="large" color="warning" @click="upgradePro=true">Activar Plan Profesional <br> Ahorra 20% </vs-button>

    <vs-popup title="Activa Plan Profesional" :active.sync="upgradePro">
      <p>Obtén todos los beneficios del Plan Profesional, con un 20% de descuento en todas las firmas extra que compres, además disfruta de todas las características para que firmes tus documentos sin preocupaciones.</p>
      <vs-button class="center-element mt-5" color="primary" type="filled"  @click="redirectPlans">Ver planes</vs-button>

    </vs-popup>
  </div>
</template>

<script>
import router from "../../../../router";

export default {
  data() {
    return {
      upgradePro: false,
      icon: 'EyeIcon',
      type: 'password',
      password: "",
      text: 'Copy Me!',
      apiKeyId: "4g0t600n-*****************************",
      apiKeySecret: "324aspagd34*****************************************************",
      webhookSecretIcon: 'EyeIcon',
      webhookSecretType: 'password',
      webhookSecret: "whsec_****************************************************************"
    }
  },
  computed: {
    isPlanProfesional() {
      return this.$store.state.account.user.me.plan.name === 'Plan Profesional' || this.$store.state.account.user.me.plan.name === 'Plan Demo';
    }
  },
  methods: {
    copyApiKeyId() {
      if (this.isPlanProfesional) {
        this.$copyText(this.apiKeyId).then(
          () => {
            this.onCopy();
          },
          () => {
            this.onError();
          }
        )
      }
    },
    copyApiKeySecret() {
      if (this.isPlanProfesional) {
        this.$copyText(this.apiKeySecret).then(
          () => {
            this.onCopy();
          },
          () => {
            this.onError();
          }
        )
      }
    },
    copyWebhookSecret() {
      if (this.isPlanProfesional) {
        this.$copyText(this.webhookSecret).then(
          () => {
            this.onCopy();
          },
          () => {
            this.onError();
          }
        )
      }
    },
    showWebhookSecret() {
      if (this.webhookSecretType === 'password') {
        this.webhookSecretType = 'text'
        this.webhookSecretIcon = 'EyeOffIcon'
      } else {
        this.webhookSecretType = 'password'
        this.webhookSecretIcon = 'EyeIcon'
      }
    },
    resetWebhookSecret() {
      let instance = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmación',
        text: 'Al regenerar la clave de webhooks, la actual deja de funcionar: tu sistema rechazará los avisos hasta que actualices la clave nueva. ¿Deseas continuar?',
        acceptText: "Si",
        cancelText: "No",
        accept: function () {
          instance.$store.dispatch("account/resetWebhookSecret").then(
            (webhookSecret) => {
              instance.webhookSecret = webhookSecret;
            },
          )
        }
      })
    },
    redirectPlans() {
      this.upgradePro = false;
      setTimeout(() => {
        router.push({name: "buy-plans"})
      }, 100)
    },
      showKey() {
        if(this.type === 'password') {
          this.type = 'text'
          this.icon = 'EyeOffIcon'
        } else {
          this.type = 'password'
          this.icon = 'EyeIcon'
        }
      },
    onCopy() {
      this.$vs.notify({
        title: 'Éxito',
        text: 'El texto se ha copiado en el portapapeles',
        color: 'success',
        position: 'top-center',
      })
    },
    onError() {
      this.$vs.notify({
        title: 'Falló',
        text: 'Falló la copia de texto',
        color: 'danger',
        position: 'top-center',
      })
    },
    resetApi() {
        this.$store.dispatch("account/resetApiKey").then(
          (apiKey) => {
            this.apiKeyId = apiKey.apiKeyId;
            this.apiKeySecret = apiKey.apiKeySecret;
          },
        )
    }
  },
  created() {
    this.$store.dispatch("account/getApiKey")
    .then(
      (apiKey) => {
        this.apiKeyId = apiKey.apiKeyId;
        this.apiKeySecret = apiKey.apiKeySecret;
      },
    )
    this.$store.dispatch("account/getWebhookSecret")
    .then(
      (webhookSecret) => {
        this.webhookSecret = webhookSecret;
      },
    )
  }
}
</script>

<style lang="scss">
.position-btn {
  max-height: 80px!important;
  position: relative;
  left: 25%;
  top: 50%;
  transform: translate(-50%, -275%)!important;
}

@media (max-width: 991px) {
  .position-btn {
    left: 50%;
  }
}
.white{
  color: #fff!important;
}
.bg-b{
  background: #fff;
  margin-right: 5px;
  margin-left: 5px;
}
.top-1{
  top: 1px;
}
.input-secret{
  .vs-con-input{
    width: 100%!important;
    margin-right: 20px!important;
  }
}
.vs-con-input-label {
  width: 100%!important;
}
.field-icon2{
  width: 50px;
  margin-left: -50px;
  margin-top: -31px;
  position: relative;
  z-index: 2;
}
.opacity{
  opacity: 0.5!important;
}
</style>
